export default __webpack_public_path__ + "static/media/plain-sticker-bo.46b8d0ef.png";